<template>
  <div style="position: relative">
    <el-carousel 
      class="banner-carousel"
      :interval=5000
      :autoplay=false>
      <el-carousel-item>
        <div class="banner-image" 
        style="background-image: url('/static/img/banner1.png')"  ></div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="banner-image" 
        style="background-image: url('/static/img/banner3.png')"  ></div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        
      }
    }
  }
</script>

<style scoped>

  .banner-carousel{
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .banner-carousel >>> .el-carousel__container{
    height: 600px;
  }

  @media screen and (max-width: 3600px) and (min-width: 2000px){
    .banner-carousel >>> .el-carousel__container{
      height: 680px;
    }
  }

  @media screen and (max-width: 1500px) and (min-width: 737px){
    .banner-carousel >>> .el-carousel__container{
      height: 400px;
    }
  }

</style>

<style lang="scss" scoped>

  .bounce-enter-active {
    animation: bounce-in .8s linear;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: translate(0px, 40px);
      opacity: 0;
    }
    50% {
      transform: translate(0px, 20px);
      opacity: 0.5;
    }

    100% {
      transform: translate(0px, 0px);
      opacity: 1;

    }
  }
  .fade1-enter-active, .fade1-leave-active {
    opacity: 0;
    animation: bounce-in .9s linear;
    animation-delay: .5s;

  }

  .fade2-enter-active, .fade2-leave-active {
    opacity: 0;
    animation: bounce-in .9s linear;
    animation-delay: 1s;

  }

</style>

<style lang="scss" scoped>
  .banner-image{
    width: 100%;
    height: 600px;
    overflow: hidden;
    background: center center no-repeat;
    background-size: cover;

  }


  @media screen and (max-width: 3600px) and (min-width: 2000px){
    .banner-image {
      height: 680px;
    }
  }

  .banner-text{
    width: 100%;
    color: white;
    max-width: 1306px;
    position: absolute;
    height: 100%;
    text-align: left;
    left: 50%;
    padding: 0 40px;
    transform: translateX(-50%);
  }
  .text-content{
    width: 100%;
    position: absolute;
    top: 260px;
    padding-left: 10px;
    transform: translateY(-50%);
  }
  .banner-logo{
    position: absolute;
    top: 140px;
    right: 50px;
    background: no-repeat;
    background-size: cover;
    width: 440px;
    height: 300px;

  }

  .font-headline1{
    font-size: 40px;
    line-height: 1.2;
    font-family: MYingHei W7,SlateForOnePlusMedium,Microsoft Yahei,sans-serif;
    font-weight: bold;
  }
  .font-headline2{
    font-size: 18px;
    font-weight: normal;
    line-height: 1.5;
    margin-top: 30px;
  }

  @media screen and (max-width: 1500px) and (min-width: 737px){
    .text-content{
      width: 100%;
      position: absolute;
      top: 200px;
      padding-left: 10px;
      transform: translateY(-50%);
    }
    .banner-image {
      height: 400px;
    }

    .banner-text{
      max-width: 1106px;

    }
    .font-headline1{
      font-size: 35px;
    }
    .banner-logo{
      width: 320px;
      height: 222px;
      top:140px
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/Header/carouselIndex.vue